export const tabsList = [
  'lightning',
  'smile',
  'phone',
  'home'
]
